// import React, { useState } from 'react';
// import { Link, Navigate, useNavigate } from 'react-router-dom';
// import { AppBar, Box, Button, CssBaseline, Divider, IconButton, Toolbar, Typography, useScrollTrigger } from '@mui/material';
// import makeStyles from '@mui/styled-engine';
// import { useLocation } from 'react-router-dom';
// import PropTypes from 'prop-types'
// import { isMobile } from 'react-device-detect';

import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { SafetyDivider } from '@mui/icons-material';

// import {TUDUblin} from 'TUDublin_RGB-removebg-preview.png';

// const useStyles = makeStyles((theme) => ({
//     '@global': {
//         ul: {
//             margin: 0,
//             padding: 0,
//             listStyle: 'none',
//         },
//     },
//     root: {
//         borderBottom: `1px solid ${theme.palette.divider}`,
//     },
//     menuButton: {
//         marginRight: theme.spacing(2),
//     },
//     title: {
//         flexGrow: 1,
//     },
//     toolbar: {
//         flexWrap: 'wrap',
//     },
//     link: {
//         margin: theme.spacing(1, 1.5),
//     },
// }));

const pages = ['Home', 'People', 'Projects', 'Publications', "Infrastructure", "News", 'Contact Us'];
const routes = ['/', 'people', 'projects', 'publications', "infrastructure", "news", 'contact']
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

// function ElevationScroll(props) {
//     const { children, window } = props;
//     // Note that you normally won't need to set the window ref as useScrollTrigger
//     // will default to window.
//     // This is only being set here because the demo is in an iframe.
//     const trigger = useScrollTrigger({
//         disableHysteresis: true,
//         threshold: 0,
//         target: window ? window() : undefined,
//     });
//     const location = useLocation();
//     console.log("Location: ", location.pathname);

//     return React.cloneElement(children, {
//         elevation: trigger ? 4 : 0,
//         sx: {
//             backgroundColor: location.pathname != "/" ? '#133F49' : (trigger ? '#133F49' : '#133F49'),
//             borderRadius: 0,

//             borderBottomStyle: trigger ? 'none' : 'solid',
//             borderBottomColor: trigger ? 'transparent' : 'white',
//             borderBottomWidth: trigger ? 'none' : 'thin'
//         }
//     });
// }

// ElevationScroll.propTypes = {
//     children: PropTypes.element.isRequired,
//     /**
//      * Injected by the documentation to work in an iframe.
//      * You won't need it on your project.
//      */
//     window: PropTypes.func,
// };

export default function NavBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 720 ? true : false)

    //choose the screen size 
    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    // create an event listener
    React.useEffect(() => {
        window.addEventListener("resize", handleResize)
    })

    return (
        <React.Fragment>
            <AppBar component={"nav"} position="sticky" style={{ borderRadius: 0, backgroundColor: '#133F49', borderTop: '1px solid white', borderBottom: '1px solid white' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-around', padding: 2 }}>
                    <Toolbar >
                        <Box sx={{ marginRight: 10 }}>
                            <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
                                <img src={isMobile ? "/images/Logo/logov1.png" : "/images/Logo/logov1.png"} color="white" href="" width={isMobile ? "50px" : "50px"} />
                            </Link>
                        </Box>

                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}

                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.map((page, index) => (
                                    <Link to={routes[index]} style={{ textDecoration: 'none', color: 'black' }}>
                                        <MenuItem key={page} onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center">{page}</Typography>
                                        </MenuItem>
                                    </Link>
                                ))}
                            </Menu>
                        </Box>
                        <Box sx={{ flexGrow: 10, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page, index) => (
                                <Link to={routes[index]} style={{ textDecoration: 'none', color: 'white', marginRight: 20 }}>
                                    <Button
                                        key={page}
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white', display: 'block' }}
                                    >
                                        {page}
                                    </Button>
                                </Link>
                            ))}
                        </Box>

                        <Box sx={{ marginLeft: 5 }}>
                            <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
                                <img src={isMobile ? "" : "/images/Logo/logov2.png"} color="white" href="" width={isMobile ? "150px" : "250px"} />
                            </Link>
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>

                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Box>
            </AppBar>
            <Outlet />

        </React.Fragment>
    );
}
